/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type GetBuildingIntelligenceTimelineSort =
    | (typeof GetBuildingIntelligenceTimelineSort)[keyof typeof GetBuildingIntelligenceTimelineSort]
    | null;

export const GetBuildingIntelligenceTimelineSort = {
    date: 'date',
    minusDate: '-date',
} as const;
